import {
  StyleSheet,
  TextInput,
  View,
  Text,
  TouchableOpacity,
  StyleProp,
  ViewStyle,
  TextInputProps,
} from "react-native";
import { colors } from "../common/styles/colors";
import { fonts } from "../common/styles/fonts";
import { AlertCircleIcon } from "../common/icons/AlertCircle";
import { useState } from "react";
import { EyeIcon } from "../common/icons/Eye";
import { EyeOffIcon } from "../common/icons/EyeOff";
import { CheckCircleIcon } from "../common/icons/CheckCircle";

export function PasswordInput({
  error,
  errorText,
  style,
  match,
  matchNoText,
  placeholder = "Password",
  containerStyle,
  ...props
}: {
  error?: boolean;
  errorText?: string;
  style?: any;
  match?: boolean;
  matchNoText?: boolean;
  placeholder?: string;
  containerStyle?: StyleProp<ViewStyle>;
} & TextInputProps) {
  const [hidePassword, setHidePassword] = useState(true);
  function switchPassword() {
    setHidePassword(!hidePassword);
  }
  return (
    <View style={[styles.container, containerStyle]}>
      <View
        style={[
          styles.inputContainer,
          style,
          (match || matchNoText) && {
            borderColor: colors.green,
            borderWidth: 1,
          },
          error && { borderColor: colors.WarningRed, borderWidth: 1 },
        ]}
      >
        <TextInput
          secureTextEntry={hidePassword}
          placeholderTextColor={colors.gray20}
          placeholder={placeholder}
          style={[fonts.mediumText_regular, styles.input]}
          {...props}
        />
        <TouchableOpacity onPress={switchPassword}>
          {hidePassword ? <EyeOffIcon /> : <EyeIcon />}
        </TouchableOpacity>
      </View>
      {errorText && (
        <View style={styles.errorContainer}>
          <Text
            style={[
              fonts.smallText_regular,
              { color: colors.WarningRed, marginRight: 4 },
            ]}
          >
            {errorText}
          </Text>
          <AlertCircleIcon />
        </View>
      )}
      {!error && match && !matchNoText && (
        <View style={styles.errorContainer}>
          <Text
            style={[
              fonts.smallText_regular,
              { color: colors.green, marginRight: 4 },
            ]}
          >
            It’s a match!
          </Text>
          <CheckCircleIcon />
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    maxWidth: 300,
    width: "100%",
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: colors.LightGrayishYellow,
    borderRadius: 10,
    borderWidth: 0.5,
    borderColor: colors.gray81,
    paddingRight: 8,
    paddingLeft: 32,
    height: 46,
  },
  input: {
    textAlign: "center",
    width: "100%",
    outlineStyle: "none",
  },
  errorContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
});
